module.exports = __webpack_public_path__ + "static/media/2.bbd64a4e.jpg";